import React from 'react';
import PropTypes from 'prop-types';
import ClickableDiv from '../ClickableDiv/index';
import { CopyIcon } from '../../styledhtml/Icon';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

export default class CopyHtmlToClipboardButton extends LogictryComponent {
  static propTypes = {
    target: PropTypes.object,
    text: PropTypes.string,
    copiedText: PropTypes.string,
  }
  state = {
    copied: false,
  }
  copyToClipboard = async () => {
    const { target } = this.props;
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(target.innerText || target.textContent);
      this.setState({ copied: true });
    } else if (document.body && document.body.createTextRange) {
      const range = document.body.createTextRange();
      range.moveToElementText(target);
      range.select().createTextRange();
      document.execCommand('copy');
      this.setState({ copied: true });
    } else if (window.getSelection) {
      const originalReadOnly = target.readOnly;
      target.readOnly = true;
      const range = document.createRange();
      range.selectNodeContents(target);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      if (target.setSelectionRange) target.setSelectionRange(0, 999999);
      document.execCommand('copy');
      this.setState({ copied: true });
      target.blur();
      target.readOnly = originalReadOnly;
    }
  }
  render() {
    const { text, copiedText } = this.props;
    const { copied } = this.state;
    return (
      <ClickableDiv onClick={this.copyToClipboard} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CopyIcon style={{ width: 14, height: 14, marginRight: 8, filter: 'invert(1)' }} />
        {(copied && copiedText && <div style={{ textDecoration: 'underline' }}>{copiedText}</div>)
          || (text && <div>{text}</div>)}
      </ClickableDiv>
    )
  }
}
